import { AlertCircle } from '@saleshandy/icons';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { accessibleOnClick } from '../../../../../shared/utils/accessible-on-click';

interface OverrideGeneratedExistingColumnProps {
  show: boolean;
  onClose: () => void;
  onProceed: () => void;
}

const OverrideGeneratedExistingColumn: React.FC<OverrideGeneratedExistingColumnProps> = ({ show, onClose, onProceed }) => (
  <Modal
    show={show}
    onHide={onClose}
    backdrop="static"
    centered
    className="override-generated-existing-column-modal"
  >
    <div className="override-generated-existing-column-modal-container">
      <div className="override-generated-existing-column-modal-content">
        <div className="override-generated-existing-column-modal-header">
          <div className="header-title">
            <AlertCircle width={24} height={24} color="#D97706" />
            <span className="line-height-1">
              Override Generated Existing Column
            </span>
          </div>
        </div>
        <div className="override-generated-existing-column-modal-body">
          <span className="override-generated-existing-column-modal-text">
            All existing values previously existed/generated in this column will be
            permanently replaced with new ones based on the latest prompt.
          </span>
          <span className="override-generated-existing-column-modal-text">
            Are you sure you want to continue?
          </span>
        </div>
      </div>
      <div className="divider-line" />
    </div>
    <div className="override-generated-existing-column-modal-footer">
      <div className="cancel-btn" {...accessibleOnClick(onClose)}>
        Cancel
      </div>
      <div className="proceed-btn">
        <Button {...accessibleOnClick(onProceed)}>Proceed Anyway</Button>
      </div>
    </div>
  </Modal>
);
export default OverrideGeneratedExistingColumn;
